var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61475 6.93473C9.747 6.57726 10.2527 6.57726 10.3849 6.93473L10.9778 8.53688C11.0609 8.76163 11.2382 8.93888 11.4629 9.02204L13.0651 9.61488C13.4225 9.74713 13.4225 10.2528 13.0651 10.385L11.4629 10.9779C11.2382 11.061 11.0609 11.2383 10.9778 11.463L10.3849 13.0652C10.2527 13.4226 9.747 13.4226 9.61475 13.0652L9.02192 11.463C8.93875 11.2383 8.7615 11.061 8.53675 10.9779L6.9346 10.385C6.57714 10.2528 6.57714 9.74713 6.9346 9.61488L8.53675 9.02204C8.7615 8.93888 8.93875 8.76163 9.02192 8.53688L9.61475 6.93473Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3333C14.6022 18.3333 18.3332 14.6023 18.3332 9.99996C18.3332 5.39759 14.6022 1.66663 9.99984 1.66663C5.39746 1.66663 1.6665 5.39759 1.6665 9.99996C1.6665 14.6023 5.39746 18.3333 9.99984 18.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 6.66663C7.22756 3.72345 8.50892 1.66663 9.99984 1.66663C11.4908 1.66663 12.7721 3.72345 13.3332 6.66663",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 13.3334C7.22756 16.2765 8.50892 18.3334 9.99984 18.3334C11.4908 18.3334 12.7721 16.2765 13.3332 13.3334",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 10H3.74984M18.3332 10H16.2498",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLink);
export default __webpack_public_path__ + "static/media/web-link.f3e6a0fcc2a4b47fbe3cb03545c60a93.svg";
export { ForwardRef as ReactComponent };